import { LoadingStatusType } from "@/enums/enums";
import { i18n } from "@/i18n";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import service from "@/service/Index";
import { ConvertToChequeDetail, ToBankAccountList, ToBankReferenceList } from "@/service/bank/bankFacade";

@Module({ namespaced: true })
export default class Bank extends VuexModule {
  public bankReferenceLanguage: any = null;
  public bankReferenceList: any = [];
  public bankReferenceLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public bankAccountLanguage: any = null;
  public bankAccountList: any = [];
  public bankAccountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public chequeDetail: any = null;
  public chequeDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getBankReferenceList() {
    return this.bankReferenceList;
  }

  get getBankReferenceLoadingStatus() {
    return this.bankReferenceLoadingStatus;
  }
  get getBankAccountList() {
    return this.bankAccountList;
  }

  get getBankAccountLoadingStatus() {
    return this.bankAccountLoadingStatus;
  }

  get getChequeDetail(): any {
    return this.chequeDetail;
  }

  get getChequeDetailLoadingStatus(): LoadingStatusType {
    return this.chequeDetailLoadingStatus;
  }

  @Mutation
  public MutationGetBankReferenceTemplate(bankReferenceList: any) {
    this.bankReferenceList = bankReferenceList;
  }

  @Mutation
  public MutationBankReferenceLanguage(locale: string) {
    this.bankReferenceLanguage = locale;
  }

  @Mutation
  public MutationBankReferenceLoadingStatus(status: LoadingStatusType) {
    this.bankReferenceLoadingStatus = status;
  }
  @Mutation
  public MutationGetBankAccountList(bankAccountList: any) {
    this.bankAccountList = bankAccountList;
  }

  @Mutation
  public MutationBankAccountLanguage(locale: string) {
    this.bankAccountLanguage = locale;
  }

  @Mutation
  public MutationBankAccountLoadingStatus(status: LoadingStatusType) {
    this.bankAccountLoadingStatus = status;
  }

  @Mutation
  public MutationChequeDetailByChequeId(chequeDetail: any) {
    this.chequeDetail = chequeDetail;
  }

  @Mutation
  public MutationSetChequeDetailLoadingStatus(status: LoadingStatusType) {
    this.chequeDetailLoadingStatus = status;
  }

  @Action
  public GetBankReferenceList() {
    if (this.bankReferenceLoadingStatus !== LoadingStatusType.Loading && i18n.locale != this.bankReferenceLanguage) {
      this.context.commit("MutationBankReferenceLanguage", i18n.locale);
      this.context.commit("MutationBankReferenceLoadingStatus", LoadingStatusType.Loading);
      service.BankService.DoGetBankReferenceList().then((res) => {
        if (res.status.IsSuccess()) {
          const bankReferenceModel = ToBankReferenceList(res.data.bankReferenceModel);
          this.context.commit("MutationGetBankReferenceTemplate", bankReferenceModel);
        }
        this.context.commit("MutationBankReferenceLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetBankAccountList() {
    if (this.bankReferenceLoadingStatus !== LoadingStatusType.Loading && i18n.locale != this.bankAccountLanguage) {
      this.context.commit("MutationBankAccountLanguage", i18n.locale);
      this.context.commit("MutationBankAccountLoadingStatus", LoadingStatusType.Loading);
      service.BankService.DoGetBankAccountList().then((res) => {
        if (res.status.IsSuccess()) {
          const bankAccountList = ToBankAccountList(res.data.bankAccountList);
          this.context.commit("MutationGetBankAccountList", bankAccountList);
        }
        this.context.commit("MutationBankAccountLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetChequeDetailByChequeId(chequeId: number) {
    if (this.chequeDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetChequeDetailLoadingStatus", LoadingStatusType.Loading);
      service.BankService.DoGetChequeDetail(chequeId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const chequeDetail = ConvertToChequeDetail(res.data.chequemodel);
          this.context.commit("MutationChequeDetailByChequeId", chequeDetail);
        }
        this.context.commit("MutationSetChequeDetailLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}
